var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 141,
    viewBox: "0 0 300 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3943_12149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H292C296.418 0 300 3.58172 300 8V141H0V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3943_12149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1336,
    cy: 143.625,
    rx: 103.652,
    ry: 89.8406,
    fill: "#E6FF00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3943_12149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2435,
    cy: 29.4929,
    rx: 85.266,
    ry: 73.9044,
    transform: "rotate(-58.9547 19.2435 29.4929)",
    fill: "#F7FFAE",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3943_12149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.921,
    cy: 35.07,
    rx: 85.266,
    ry: 73.9044,
    transform: "rotate(-58.9547 149.921 35.07)",
    fill: "#F7FFAE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3943_12149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.586,
    cy: 36.664,
    rx: 85.266,
    ry: 73.9044,
    transform: "rotate(-149.336 233.586 36.664)",
    fill: "#F7FFAE",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3943_12149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 276,
    height: 202,
    rx: 4.78088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3943_12149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5008,
    cy: 110.956,
    rx: 103.652,
    ry: 89.8406,
    fill: "#E6FF00",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3943_12149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.652,
    cy: 110.841,
    rx: 103.652,
    ry: 89.8406,
    fill: "#E6FF00",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 54.1836,
    y: 53.7842,
    width: 276.096,
    height: 190.04,
    rx: 4.78088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3943_12149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.416 68.8633H106.349C103.508 68.8633 101.204 71.1668 101.204 74.0083V260.382C101.204 263.224 103.508 265.527 106.349 265.527H231.416C234.257 265.527 236.561 263.224 236.561 260.382V74.0083C236.561 71.1668 234.257 68.8633 231.416 68.8633Z",
    fill: "#F7FCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M229.396 80.2944H108.368V256.172H229.396V80.2944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.076 67.1875H136.698C135.966 67.1875 135.372 67.7811 135.372 68.5133V76.77C135.372 77.5022 135.966 78.0957 136.698 78.0957H201.076C201.808 78.0957 202.401 77.5022 202.401 76.77V68.5133C202.401 67.7811 201.808 67.1875 201.076 67.1875Z",
    fill: "#E6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.076 67.1875H136.698C135.966 67.1875 135.372 67.7811 135.372 68.5133V76.77C135.372 77.5022 135.966 78.0957 136.698 78.0957H201.076C201.808 78.0957 202.401 77.5022 202.401 76.77V68.5133C202.401 67.7811 201.808 67.1875 201.076 67.1875Z",
    fill: "#E3FC01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.723 70.519H147.069C146.629 70.519 146.272 70.8758 146.272 71.3159V74.407C146.272 74.8471 146.629 75.2038 147.069 75.2038H190.723C191.163 75.2038 191.52 74.8471 191.52 74.407V71.3159C191.52 70.8758 191.163 70.519 190.723 70.519Z",
    fill: "#E6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M190.702 70.519H147.049C146.609 70.519 146.252 70.8758 146.252 71.3159V74.407C146.252 74.8471 146.609 75.2038 147.049 75.2038H190.702C191.142 75.2038 191.499 74.8471 191.499 74.407V71.3159C191.499 70.8758 191.142 70.519 190.702 70.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M205.024 98.4077H132.403C131.775 98.4059 131.173 98.1556 130.729 97.7116C130.285 97.2675 130.035 96.6658 130.033 96.0378C130.033 95.4093 130.283 94.8065 130.727 94.3621C131.172 93.9177 131.775 93.668 132.403 93.668H205.024C205.652 93.668 206.255 93.9177 206.7 94.3621C207.144 94.8065 207.394 95.4093 207.394 96.0378C207.392 96.6658 207.142 97.2675 206.698 97.7116C206.254 98.1556 205.652 98.4059 205.024 98.4077Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M217.135 112.434H169.202C168.855 112.432 168.523 112.293 168.278 112.047C168.034 111.801 167.896 111.469 167.896 111.122C167.896 110.776 168.034 110.444 168.279 110.199C168.524 109.954 168.855 109.817 169.202 109.817H217.135C217.481 109.817 217.813 109.954 218.057 110.199C218.302 110.444 218.44 110.776 218.44 111.122C218.44 111.469 218.302 111.801 218.058 112.047C217.813 112.293 217.481 112.432 217.135 112.434Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M210.265 119.304H169.202C168.855 119.302 168.523 119.163 168.278 118.917C168.034 118.671 167.896 118.338 167.896 117.992C167.896 117.646 168.034 117.314 168.279 117.069C168.524 116.824 168.855 116.687 169.202 116.687H210.265C210.612 116.687 210.944 116.824 211.188 117.069C211.433 117.314 211.571 117.646 211.571 117.992C211.571 118.338 211.433 118.671 211.189 118.917C210.944 119.163 210.612 119.302 210.265 119.304Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M217.135 126.172H169.202C168.855 126.171 168.523 126.031 168.278 125.786C168.034 125.54 167.896 125.207 167.896 124.86C167.896 124.514 168.034 124.182 168.279 123.937C168.524 123.693 168.855 123.555 169.202 123.555H217.135C217.481 123.555 217.813 123.693 218.057 123.937C218.302 124.182 218.44 124.514 218.44 124.86C218.44 125.207 218.302 125.54 218.058 125.786C217.813 126.031 217.481 126.171 217.135 126.172Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M203.396 133.042H169.202C168.855 133.041 168.523 132.902 168.278 132.656C168.034 132.41 167.896 132.077 167.896 131.73C167.896 131.384 168.034 131.052 168.279 130.808C168.524 130.563 168.855 130.425 169.202 130.425H203.396C203.742 130.425 204.074 130.563 204.319 130.808C204.564 131.052 204.701 131.384 204.701 131.73C204.701 132.077 204.564 132.41 204.32 132.656C204.075 132.902 203.743 133.041 203.396 133.042Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.093 109.817H116.007V168.356H160.093V109.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.032 111.878H118.067V166.296H158.032V111.878Z",
    fill: "#E6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.032 111.878H118.067V166.296H158.032V111.878Z",
    fill: "#E3FC01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.474 149.22C149.377 149.714 149.281 150.216 149.171 150.71C149.061 151.205 148.91 151.885 148.766 152.469C147.269 158.493 144.796 163.768 141.251 166.296H129.134C125.61 164.503 124.937 161.488 125.054 158.328C125.129 156.192 125.569 154.014 125.741 152.146C125.795 151.501 125.795 150.853 125.741 150.209C125.651 149.233 125.466 148.059 125.239 146.774C124.188 140.791 122.134 132.157 123.178 127.726C124.422 122.341 128.351 120.857 128.351 120.857C128.351 120.857 129.684 120.767 131.731 120.781C133.242 120.781 135.165 120.857 137.178 121.049H137.322C139.579 121.252 141.815 121.648 144.006 122.231L144.507 122.375C144.94 122.505 145.373 122.643 145.792 122.794C146.066 122.89 146.334 122.993 146.602 123.103C146.95 123.25 147.263 123.468 147.523 123.742C150.634 126.936 151.404 138.648 149.474 149.22Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.854 123.769C150.216 121.708 152.099 135.934 150.539 146.204",
    stroke: "#181B01",
    strokeWidth: 0.343458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.302 158.396C139.418 155.406 136.144 152.818 132.568 150.703C135.247 148.436 134.973 144.864 134.437 142.618C134.267 141.913 134.037 141.223 133.75 140.557L141.189 142.357C140.96 143.393 140.806 144.444 140.729 145.503C140.665 146.282 140.695 147.066 140.818 147.838C141.21 150.112 142.487 150.208 142.487 150.208C143.703 152.764 142.302 158.396 142.302 158.396Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M140.757 145.496C140.692 146.275 140.722 147.059 140.846 147.832C137.885 147.282 135.749 144.775 134.437 142.632C134.267 141.926 134.037 141.237 133.75 140.571L141.189 142.371C140.97 143.401 140.825 144.445 140.757 145.496Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.401 121.014C146.499 121.014 147.179 124.93 147.646 131.675C148.223 140.11 146.341 146.1 138.16 144.273C127.053 141.807 127.527 121.014 138.401 121.014Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.415 131.305C143.935 132.294 144.571 133.216 145.311 134.053C145.121 134.324 144.859 134.538 144.554 134.669C144.25 134.8 143.915 134.843 143.587 134.795L143.415 131.305Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41 130.782C139.41 131.325 139.142 131.764 138.778 131.771C138.414 131.778 138.091 131.352 138.091 130.81C138.091 130.267 138.359 129.834 138.716 129.827C139.073 129.82 139.396 130.219 139.41 130.782Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.593 129.827L139.754 129.339C139.754 129.339 139.19 130.335 138.593 129.827Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.093 130.5C146.093 131.043 145.825 131.483 145.461 131.489C145.097 131.496 144.774 131.07 144.774 130.528C144.774 129.985 145.042 129.552 145.399 129.545C145.757 129.539 146.08 129.965 146.093 130.5Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.277 129.574L146.431 129.093C146.431 129.093 145.909 130.096 145.277 129.574Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.355 126.234C139.355 126.234 137.514 125.994 136.511 127.217",
    stroke: "#181B01",
    strokeWidth: 0.48631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.116 125.974C144.563 125.862 145.029 125.852 145.48 125.946C145.931 126.04 146.355 126.236 146.72 126.517",
    stroke: "#181B01",
    strokeWidth: 0.48631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36 132.423C131.36 132.423 134.43 127.052 133.977 122.896C133.977 122.896 138.593 118.135 144.81 122.841C144.81 122.841 147.413 127.319 147.557 130.795C147.557 130.795 148.849 119.118 137.597 118.822C126.345 118.527 126.373 134.999 132.17 139.917C132.17 139.917 129.457 135.782 131.36 132.423Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.424 133.804C132.361 133.047 132.001 132.346 131.424 131.853C130.846 131.361 130.097 131.116 129.34 131.173C127.279 131.393 126.331 135.556 131.4 136.565C132.101 136.71 132.513 136.002 132.424 133.804Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.701 138.338C142.701 138.338 139.954 138.957 138.82 136.504",
    stroke: "#181B01",
    strokeWidth: 0.48631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.977 122.897C133.977 122.897 141.458 119.579 146.411 123.962C146.411 123.962 148.355 118.192 141.719 116.22C135.083 114.249 128.338 120.885 128.338 120.885L133.977 122.897Z",
    fill: "#181B01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.977 122.896C133.977 122.896 129.608 127.203 130.24 135.783C130.872 144.362 130.041 149.789 128.337 155.161C126.633 160.532 131.085 162.133 131.085 162.133C131.085 162.133 126.001 163.383 124.957 157.943C124.27 154.371 125.905 146.636 125.081 137.425C124.257 128.213 127.547 121.694 133.977 122.896Z",
    fill: "#181B01"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3943_12149",
    x: -123.134,
    y: 1.16887,
    width: 312.535,
    height: 284.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077,
    result: "effect1_foregroundBlur_3943_12149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3943_12149",
    x: -101.136,
    y: -96.2036,
    width: 240.758,
    height: 251.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6411,
    result: "effect1_foregroundBlur_3943_12149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3943_12149",
    x: 29.542,
    y: -90.6265,
    width: 240.758,
    height: 251.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6411,
    result: "effect1_foregroundBlur_3943_12149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3943_12149",
    x: 107.825,
    y: -83.6465,
    width: 251.521,
    height: 240.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6411,
    result: "effect1_foregroundBlur_3943_12149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3943_12149",
    x: -114.767,
    y: -31.5001,
    width: 312.535,
    height: 284.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077,
    result: "effect1_foregroundBlur_3943_12149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3943_12149",
    x: 48.3847,
    y: -31.6153,
    width: 312.535,
    height: 284.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077,
    result: "effect1_foregroundBlur_3943_12149"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3943_12149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H292C296.418 0 300 3.58172 300 8V141H0V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3943_12149"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 276,
    height: 202,
    rx: 4.78088,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3943_12149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.565,
    height: 147,
    fill: "white",
    transform: "translate(96.3945 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProfileIcon);
export default __webpack_public_path__ + "static/media/create-profile-icon.10bf05bd5066ab83cfad3edab0cae064.svg";
export { ForwardRef as ReactComponent };